import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import HomePageJumbotron from './HomePageJumbotron';
import HomePageStory from './HomePageStory';
import HomePageExhibitionList from './HomePageExhibitionList';
import HomePageAwardList from './HomePageAwardList';
import HomePageNews from './HomePageNews';
import HomePageGreetingCardAdvert from './HomePageGreetingCardAdvert';
import { Helmet } from "react-helmet";

class HomePage extends React.Component {
    constructor(props, context) {
        super(props, context);
    }
    render() {
        const exhibitions = this.props.exhibitions;
        const awards = this.props.awards;

        return (
            <div className="homePage">
                <Helmet>
                    <title>Home | Ailsa Lyn Artist</title>
                    <meta name="description" content="Ailsa Lyn - A Suffolk based artist specialising collages and watercolours." />
                </Helmet>
                <HomePageJumbotron />
                <HomePageStory />
                {exhibitions.length > 0 &&
                    <HomePageExhibitionList exhibitions={exhibitions} />
                }
                <HomePageNews />
                {awards.length > 0 &&
                    <HomePageAwardList awards={awards} />
                }
                <HomePageGreetingCardAdvert />
            </div>
        );
    }
}

HomePage.propTypes = {
    loading: PropTypes.bool.isRequired,
    exhibitions: PropTypes.array.isRequired,
    awards: PropTypes.array.isRequired
};

function mapStateToProps(state) {
    return {
        loading: state.ajaxCallsInProgress > 0,
        exhibitions: state.exhibitions,
        awards: state.awards
    };
}

export default connect(
    mapStateToProps
)(HomePage);



// WEBPACK FOOTER //
// ./src/components/homePage/HomePage.js